import { TranslationMap } from '@trimble-gcs/i18n-types';

export function host3dTranslations() {
  return {
    elevation: {
      title: {
        text: $localize`:@@host3d.elevation.title:Elevation Picking`,
        desc: 'Title for the elevation value as selected from the 3D scene with a mouse click.',
      },
      usage: {
        text: $localize`:@@host3d.elevation.usage:Select a point in the scene to use as a reference.`,
        desc: 'Usages text for the reference elevation value that was selected from the 3D scene with a mouse click.',
      },
    },
  } satisfies TranslationMap;
}
